import ModalLayout from "../../layout/ModalLayout.tsx";
import NewEntityForm from "../formik/NewEntityForm.tsx";
import {ModalType} from "./NewApplicationModal.tsx";


export default function NewEntityModal({show, onClose, data}: ModalType) {
    return (
        <>
            {show && (
                <ModalLayout
                    title={"Add new entity"}
                    text={"Add a new entity to your project"}
                    onClose={() => console.log("hey")}
                >
                    <NewEntityForm onClose={onClose} data={data}/>
                </ModalLayout>
            )}
        </>
    );
}
